/**
 * Stripe plan configuration (display only).
 *
 * The backend is the source of truth for price IDs — the client sends a plan
 * key ('monthly' | 'annual') and the server maps it to STRIPE_PRICE_*.
 * Price IDs are kept here only for reference / potential client-side use.
 */

export const STRIPE_PRICE_MONTHLY =
  process.env.REACT_APP_STRIPE_PRICE_MONTHLY || 'price_1TfZjyLuVnLXhUztJqnGuJ4A';
export const STRIPE_PRICE_ANNUAL =
  process.env.REACT_APP_STRIPE_PRICE_ANNUAL || 'price_1TfZkhLuVnLXhUzt9YwYmyCO';

export const STRIPE_PLANS = {
  monthly: {
    key: 'monthly',
    price: '$5',
    period: '/month',
    caption: 'Billed monthly',
  },
  annual: {
    key: 'annual',
    price: '$33',
    period: '/year',
    caption: 'Save 45% · $2.75/month',
  },
};

export const STANDARD_FEATURES = [
  'All 15 asset maps',
  'PDF & CSV export',
  'AI-assisted map completion',
  'Continuity planning & nominee sharing',
];
